<template>
  <div>
    <div class="right-box">
      <div class="wechart-box">
        <p class="title">扫码下载APP</p>
        <div>
          <img src="@/assets/img/code_app.png" alt />
        </div>
        <p>
          扫描二维码下载APP
          <br />随时随地畅听优质好文
        </p>
      </div>
    </div>

    <div class="right-box" style="margin-top:30px" v-if="right_adv.url">
      <div class="rightTop">
        <img
          width="100%"
          :src="right_adv.url"
          alt=""
          @click="rightAdvClick(right_adv.param, right_adv.url)"
        />
        <span>广告</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getone, advclick } from "@/api/adv";
export default {
  props: {
    keys: {
      type: [String, Number], //可指定接收类型，如:Array.
      default: "" //可设置默认值
    }
  },
  data() {
    return {
      keyword: "",
      //右侧广告
      right_adv: {
        image: "",
        url: "",
        param: ""
      }
    };
  },
  methods: {
    rightAdvClick(data, url) {
      this.$parent.rightAdvClick(data, url);
    }
  },
  created() {
    //右侧广告
    this.keyword = this.keys.toString();
    getone(583, this.keyword).then(res => {
      try {
        if (res != "" && res.data != "" && res.data.return_code == 0) {
          if (res.data.direct_creatives_info[0].adsold) {
            this.right_adv.url = res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.right_adv.image = img.imgUrl;
            this.right_adv.param = res.data.direct_creatives_info[0];
          }
        }
      } catch (error) {}
    });
  }
};
</script>
<style lang="scss" scoped>
.right-box {
  background: #fff;
  text-align: center;
  font-size: 16px;
  .wechart-box {
    padding: 30px;
    p {
      line-height: 24px;
    }
    .title {
      font-weight: 600;
    }
    p:last-child {
      color: #0091ff;
    }
    div {
      max-width: 200px;
      padding: 20px 30px 10px 30px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

//新增广告样式
.rightTop {
  position: relative;
  width: 320px;
  height: 250px;
  background: #fff;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wechart.vue